module.exports = __webpack_public_path__ + "img/product_img2.d999a87d.png";